const getDefaultState = () => {
  return {
    token: '',
    selectOrgId: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_SELECT_ORG_ID: (state, orgId) => {
    state.selectOrgId = orgId
  }
}

const actions = {
  // user login
  setUserData ({commit}, data) {
    const {token} = data
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', token)
    })
  },
  updateToken ({commit}, data) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', data)
    })
  },
  // select org id
  selectOrgId ({commit}, data) {
    return new Promise((resolve, reject) => {
      commit('SET_SELECT_ORG_ID', data)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js